import { createContext } from 'react';
import { FlexyFilterValue } from '../DatatableHeader';

type FlexyFilterContextType = {
    rawValue: FlexyFilterValue;
    setRawValue: (rawValue: FlexyFilterValue) => void;
};

export const FlexyFilterContext = createContext<FlexyFilterContextType>({
    rawValue: null,
    setRawValue: () => {},
});
